import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Hardcoded config for testing
const firebaseConfig = {
  apiKey: "AIzaSyAWz6k1b1xU0DD_h1Mo1rauu_lLWsbWgWo",
  authDomain: "auctionringers-e6565.firebaseapp.com",
  projectId: "auctionringers-e6565",
  storageBucket: "auctionringers-e6565.firebasestorage.app",
  messagingSenderId: "965810167610",
  appId: "1:965810167610:web:47fb74c94803fcdcb1fa03"
};

// Initialize Firebase
console.log('Initializing Firebase with config:', firebaseConfig);
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

console.log('Firebase initialized successfully');
console.log('Firestore instance:', db);
console.log('Storage instance:', storage);

export default app;